export const environment = {
  version: 1.0,
  production: true,
  isServer: true,
  // for prerender

  host: 'https://temared.com',
  cdn: 'https://temared.com/uploads',
  api: 'https://temared.com/app',
  base: 'https://temared.com',
  socket: 'https://peer.eu',
  currencies: ['PLN', 'EUR', 'GBP'],
  withavatar: true,
  name: 'Temared'
};